import * as Radix from '@radix-ui/react-accordion';

import * as styles from './index.css';

import type { AccordionProps } from '@lib/queries';

import { Box } from '~/components/box';
import { StructuredText } from '~/components/structured-text';
import { Text } from '~/components/text';
import { ChevronDown } from '~/icons';

export const Accordion = ({ title, description, items }: AccordionProps) => (
  <Radix.Root type="multiple">
    <Box display="flex" flexDirection="column" gap="0.5">
      <Text lineHeight="snug" display="inline" variant="h1">
        <StructuredText heading value={title} />
      </Text>
      {description && <StructuredText value={description} />}
    </Box>
    <Box marginTop="2" display="flex" flexDirection="column" gap="2">
      {items?.map((item) => (
        <Radix.Item key={item.title} value={item.title}>
          <Radix.Trigger asChild>
            <Box cursor="pointer" className={styles.trigger}>
              <Radix.Header>
                <Box display="flex" alignItems="center" justifyContent="space-between" marginBottom="0.5">
                  <Text variant="h3" paddingRight="2">
                    {item.title}
                  </Text>

                  <Box>
                    <Box cursor="pointer" height="2" className={styles.chevron}>
                      <ChevronDown />
                    </Box>
                  </Box>
                </Box>
              </Radix.Header>
              <Radix.Content className={styles.content}>
                <Text variant="body">
                  <StructuredText heading value={item.body} />
                </Text>
              </Radix.Content>
            </Box>
          </Radix.Trigger>
        </Radix.Item>
      ))}
    </Box>
  </Radix.Root>
);
